export const createVefPrintViewModelV2 = ({ voyages, totals, generatedAt, t }) => {
  if (!Array.isArray(voyages) || voyages.length === 0) {
    throw new Error("No voyage data available for print.");
  }

  return {
    title: t("title"),
    generatedAt,
    voyages,
    totals: {
      totalShipAll: 0,
      totalShoreAll: 0,
      overallRatio: 0,
      totalShipQualified: 0,
      totalShoreQualified: 0,
      vef: 0,
      ...totals,
    },
  };
};
